import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { EnvironmentService } from "@services/environment.service";
import { Router } from "@angular/router";

@Component({
  selector: "scaffold-direct-link",
  templateUrl: "./direct-link.component.html",
  styleUrls: ["./direct-link.component.scss"],
})
export class DirectLinkComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private environmentService:EnvironmentService,
    private router:Router
  ) {
    super(cdr, renderedService);
  }

  get _url() {
    return "/"+this.item?.link_target
  }

  ngOnInit(): void {
  }
}
